"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cookies_1 = require("@zapier/cookies");
var isProduction_1 = __importDefault(require("./isProduction"));
var setCookie = function (id, value, maxAge, path) {
    if (path === void 0) { path = '/'; }
    if (!isProduction_1.default()) {
        // Consider switching to `writeCookie` from `@zapier/cookies`.
        // eslint-disable-next-line no-console
        console.warn('@zapier/common-utils `setCookie` is deprecated.');
    }
    try {
        cookies_1.writeCookie(id, value, {
            // Cookies are categorized as `essential` for backwards compatibility,
            // but devs should use `writeCookie` from `@zapier/cookies` with
            // the correct `category`.
            category: 'essential',
            maxAge: maxAge,
            path: path,
        });
    }
    catch (e) {
        console.error('Unable to set cookie', {
            id: id,
        });
    }
};
exports.default = setCookie;
